module.exports = __webpack_public_path__ + "static/img/makehole8.74253e7b.png";